// Meme regle que Iban.TryParse cote serveur, pour signaler la faute de frappe
// avant l'envoi. Le serveur refait le controle.

const lengthByCountry: Record<string, number> = {
  AD: 24, AT: 20, BE: 16, CH: 21, CY: 28, DE: 22, DK: 18, EE: 20, ES: 24, FI: 18,
  FR: 27, GB: 22, GR: 27, HR: 21, IE: 22, IT: 27, LT: 20, LU: 20, LV: 21, MC: 27,
  MT: 31, NL: 18, NO: 15, PL: 28, PT: 25, SE: 24, SI: 19, SK: 24, SM: 27,
}

export function compactIban(input: string): string {
  return input.replace(/\s+/g, '').toUpperCase()
}

export function formatIban(input: string): string {
  return compactIban(input).replace(/(.{4})(?=.)/g, '$1 ')
}

function mod97(compact: string): number {
  const rearranged = compact.slice(4) + compact.slice(0, 4)
  let remainder = 0

  for (const character of rearranged) {
    const value = /\d/.test(character) ? Number(character) : character.charCodeAt(0) - 55
    remainder = (remainder * (value > 9 ? 100 : 10) + value) % 97
  }

  return remainder
}

export function ibanError(input: string): string | null {
  const compact = compactIban(input)

  if (compact.length === 0) {
    return "L'IBAN est obligatoire."
  }

  if (compact.length < 15 || compact.length > 34) {
    return 'Un IBAN compte entre 15 et 34 caracteres.'
  }

  if (!/^[A-Z]{2}\d{2}/.test(compact)) {
    return 'Un IBAN commence par le code du pays (deux lettres) puis deux chiffres de controle.'
  }

  if (!/^[A-Z0-9]+$/.test(compact)) {
    return 'Un IBAN ne contient que des lettres et des chiffres.'
  }

  const country = compact.slice(0, 2)
  const expected = lengthByCountry[country]
  if (expected !== undefined && compact.length !== expected) {
    return `Un IBAN ${country} compte ${expected} caracteres, celui-ci en a ${compact.length}.`
  }

  if (mod97(compact) !== 1) {
    return 'La cle de controle de cet IBAN est fausse : verifiez la saisie.'
  }

  return null
}
